import EN from "@/constants/en";

const techIcons = EN.TECHNOLOGIES_LIST;

const Education = () => {
    return (
        <section id="technologies" className="section bg-white">
            <div className="container-custom">
                <h2 className="section-title">{EN.TECHNOLOGIES_SECTION_TITLE}</h2>
                <div className="flex flex-wrap justify-center gap-16">
                    {techIcons.map((icon, index) => (
                        <div key={index} className="w-20 h-20 relative flex flex-row items-center justify-center">
                            <img
                                src={icon.src}
                                alt={`${icon.name} ${EN.HERO_BG_LOGO_ALT_SUFFIX}`}
                                className="w-full h-full object-contain"
                                style={{ objectFit: "contain" }}
                                sizes="(max-width: 640px) 60px, 80px"
                                loading="lazy"
                                decoding="async"
                                width="80"
                                height="80"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Education;
